import { request } from './client';

export interface ApiKey {
  id: string;
  prefix: string;
  suffix: string;
  name: string | null;
  openrouter_enabled: boolean;
  last_used_at: string | null;
  revoked_at: string | null;
  created_at: string;
}

export interface CreateKeyResponse {
  key: ApiKey;
  raw_key: string;
  warning: string;
}

export const keysApi = {
  list: () => request<{ keys: ApiKey[] }>('/api/keys'),
  create: (name: string | null) =>
    request<CreateKeyResponse>('/api/keys', { method: 'POST', body: name ? { name } : {} }),
  revoke: (id: string) => request<{ ok: true }>(`/api/keys/${id}`, { method: 'DELETE' }),
  setOpenrouter: (id: string, enabled: boolean) =>
    request<{ ok: true }>(`/api/keys/${id}`, {
      method: 'PATCH',
      body: { openrouter_enabled: enabled },
    }),
};
